/**
 * Alaska Reserve — review-uri: randare din API + submit cu upload poze.
 * Backend: reviews.alaskareserve.com (Worker propriu).
 */
(function () {
  'use strict';

  var root = document.getElementById('brand-reviews');
  if (!root) return;
  var API = root.getAttribute('data-api');
  var HANDLE = root.getAttribute('data-handle');
  var listEl = document.getElementById('brand-reviews-list');
  var scoreEl = document.getElementById('brand-reviews-score');
  var form = document.getElementById('brand-reviews-form');
  var msgEl = document.getElementById('brand-reviews-msg');

  function flagEmoji(cc) {
    if (!cc || cc.length !== 2) return '';
    return String.fromCodePoint(...[...cc.toUpperCase()].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
  }

  function stars(n) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += i <= n ? '★' : '☆';
    return s;
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function showMsg(text, ok) {
    if (!msgEl) return;
    msgEl.hidden = false;
    msgEl.textContent = text;
    msgEl.classList.toggle('brand-reviews__msg--ok', !!ok);
    msgEl.classList.toggle('brand-reviews__msg--err', !ok);
  }

  /* ---------- randarea review-urilor aprobate ---------- */

  function renderReviews(data) {
    var n = data.count || 0;
    if (scoreEl) {
      if (n > 0) {
        var avg = Math.round(data.average);
        scoreEl.innerHTML =
          '<span class="brand-reviews__stars" aria-hidden="true">' + stars(avg) + '</span> ' +
          n + ' review' + (n === 1 ? '' : 's') + ' — all verified';
      } else {
        scoreEl.innerHTML = '<span class="brand-reviews__score--empty">Be the first to write a review</span>';
      }
    }
    if (!listEl) return;
    listEl.innerHTML = (data.reviews || []).map(function (r) {
      var photos = (r.photos || []).map(function (u) {
        return '<a href="' + API + esc(u) + '" target="_blank" rel="noopener">' +
          '<img src="' + API + esc(u) + '" alt="Customer photo" loading="lazy"></a>';
      }).join('');
      var dateStr = '';
      if (r.date) {
        try {
          var dt = new Date(r.date.replace(' ', 'T') + 'Z');
          dateStr = dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) +
            ', ' + dt.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true });
        } catch (e) { dateStr = (r.date || '').slice(0, 10); }
      }
      var country = r.country && r.country !== 'T1' ? flagEmoji(r.country) : '';
      return '<article class="brand-reviews__item">' +
        '<span class="brand-reviews__stars" aria-label="' + r.rating + ' out of 5 stars">' + stars(r.rating) + '</span>' +
        (r.title ? '<h3 class="brand-reviews__item-title">' + esc(r.title) + '</h3>' : '') +
        (r.body ? '<p class="brand-reviews__body">' + esc(r.body) + '</p>' : '') +
        (photos ? '<div class="brand-reviews__photos">' + photos + '</div>' : '') +
        '<footer class="brand-reviews__item-foot">' +
        '<strong class="brand-reviews__author">' + esc(r.author || 'Verified customer') + '</strong>' +
        (country ? '<span class="brand-reviews__date">' + esc(country) + '</span>' : '') +
        (dateStr ? '<time class="brand-reviews__date">' + esc(dateStr) + '</time>' : '') +
        '</footer></article>';
    }).join('');
  }

  fetch(API + '/api/reviews?handle=' + encodeURIComponent(HANDLE))
    .then(function (r) { return r.json(); })
    .then(function (d) { if (d && d.ok) renderReviews(d); })
    .catch(function () { /* fallback: ce e randat server-side rămâne */ });

  /* ---------- submit cu validare instant a codului + upload ---------- */

  if (!form) return;

  function submitDisabled(d) {
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = d; btn.textContent = d ? 'Submitting…' : 'Submit review'; }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var fd = new FormData(form);
    if (fd.get('website')) return; // honeypot: bot

    var code = (fd.get('code') || '').toString().trim().toUpperCase();
    var rating = parseInt(fd.get('rating'), 10);
    var files = (form.querySelector('input[name="photos"]').files || []);
    if (!/^AR-[A-Z0-9]{4,10}$/.test(code)) {
      showMsg('The review code looks wrong — it should look like AR-4K7T2, exactly as in our email.', false);
      return;
    }
    if (!(rating >= 1 && rating <= 5)) {
      showMsg('Please choose a rating.', false);
      return;
    }
    if (files.length > 5) {
      showMsg('Maximum 5 photos per review.', false);
      return;
    }

    submitDisabled(true);
    showMsg('Checking your review code…', true);

    // 1) validare instant a codului
    fetch(API + '/api/codes/verify?code=' + encodeURIComponent(code))
      .then(function (r) { return r.json(); })
      .then(function (v) {
        if (!v.valid) {
          submitDisabled(false);
          if (v.reason === 'rate_limited') {
            showMsg('Too many attempts — please wait a minute and try again.', false);
          } else if (v.reason === 'used') {
            showMsg('This code was already used for a published review. Each code works once.', false);
          } else if (v.reason === 'revoked') {
            showMsg('This code was cancelled — if the order was returned, the code no longer works. Contact us at office@alaskareserve.com if you believe this is a mistake.', false);
          } else {
            showMsg('This code is not valid — check the email we sent after delivery. The review was not submitted.', false);
          }
          return null;
        }
        // 2) trimiterea propriu-zisă (multipart, cu pozele reale)
        var out = new FormData();
        out.append('code', code);
        out.append('rating', String(rating));
        out.append('name', fd.get('name') || '');
        out.append('title', fd.get('title') || '');
        out.append('body', fd.get('body') || '');
        out.append('website', fd.get('website') || '');
        for (var i = 0; i < files.length; i++) out.append('photos', files[i], files[i].name);
        return fetch(API + '/api/reviews', { method: 'POST', body: out })
          .then(function (r) { return r.json(); });
      })
      .then(function (res) {
        if (!res) return; // cod invalid: mesaj deja afișat
        submitDisabled(false);
        if (res.ok) {
          form.reset();
          showMsg('Thank you! Your review is now live on this page.', true);
          fetch(API + '/api/reviews?handle=' + encodeURIComponent(HANDLE))
            .then(function (r) { return r.json(); })
            .then(function (d) { if (d && d.ok) renderReviews(d); })
            .catch(function () {});
          if (msgEl.scrollIntoView) msgEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } else {
          var msgs = {
            invalid_code: 'This code is not valid — the review was not submitted.',
            code_used: 'This code was already used. Each code works once.',
            too_many_photos: 'Maximum 5 photos per review.',
            bad_photo_type: 'Photos must be JPG, PNG or WebP.',
            vpn_not_allowed: 'Reviews submitted through VPN or proxy connections cannot be published. Please disconnect the VPN and try again.',
            photo_too_large: 'Each photo must be under 5MB.',
          };
          showMsg(msgs[res.error] || 'Something went wrong — please try again.', false);
        }
      })
      .catch(function () {
        submitDisabled(false);
        showMsg('Connection problem — please try again in a moment.', false);
      });
  });
})();
